import { createSlug } from "@suse-o11y/create-slug";
import React from "react";

import { Truncated } from "~/components/truncated";
import { HealthStateValue, type QueryView } from "~/models/dto";

import { HealthStateCircle } from "../../../components/react/HealthCircle/HealthStateCircle";
import { useNavigateToLink } from "../../../components/react/link";
import { ViewStar } from "../../../components/react/star/ViewStar";
import { VIEW_PATH } from "../../../routes/Routes";
import { MainMenuItemLayout } from "../MainMenuItemLayout";

const ViewLabel: React.FC<{
	view: QueryView;
	name: string;
}> = ({ view, name }) => (
	<div className="flex flex-row items-center justify-start">
		<Truncated>{name}</Truncated>
		<ViewStar className="relative ml-2" viewId={view.id!} />
	</div>
);

export interface ViewMenuItemViewProps {
	view: QueryView;
}

export const ViewMenuItemView: React.FC<ViewMenuItemViewProps> = ({ view }) => {
	const link = useNavigateToLink(VIEW_PATH, {
		params: {
			slug: view.identifier ?? createSlug(view.name),
		},
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			data-trackid="lp-starred_view"
			icon={<HealthStateCircle size="small" state={HealthStateValue.Uninitialized} />}
			label={<ViewLabel name={view.name} view={view} />}
			level={1}
			to={link}
		/>
	);
};
